import { lruMemoize } from '@reduxjs/toolkit';

import type {
  SearchCriteriaFilterSchema,
  SearchSearchCriteriaSchema,
} from '@iconik-io/iconik-api/src/services/search';

type Options = {
  escapeMinus?: boolean;
  addAsteriskOnlyToEndOfQuery?: boolean;
  keepSpaceAtEnd?: boolean;
};

// Falsy input is handed straight back. Overloaded rather than widened so the
// common case stays `string | undefined`.
export function prepareQueryParameter(
  query: string | undefined,
  options?: Options,
): string | undefined;
export function prepareQueryParameter(query: null, options?: Options): null;
export function prepareQueryParameter(
  query: string | null | undefined,
  options?: Options,
): string | null | undefined {
  if (!query) {
    return query;
  }

  let queryLowerCase = query.toLowerCase();

  queryLowerCase = queryLowerCase.replace(/"/g, '\\"');

  if (options?.escapeMinus) {
    queryLowerCase = queryLowerCase.replace(/-/g, '"-"');
  }

  if (!options?.keepSpaceAtEnd && query.endsWith(' ')) {
    return queryLowerCase.trimEnd();
  }

  if (!queryLowerCase) {
    return '';
  }
  if (!queryLowerCase.endsWith('*')) {
    queryLowerCase += '*';
  }

  if (
    !queryLowerCase.startsWith('*') &&
    !options?.addAsteriskOnlyToEndOfQuery
  ) {
    queryLowerCase = `*${queryLowerCase}`;
  }

  return queryLowerCase;
}

export const extractFiltersFromSearchDocument = lruMemoize(
  (
    searchFilters?: SearchSearchCriteriaSchema,
  ): SearchCriteriaFilterSchema[] => {
    if (!searchFilters) {
      return [];
    }
    const defaultFilters = searchFilters.filter?.terms
      ? [searchFilters.filter]
      : [];
    return searchFilters.filter?.filters?.[0]?.filters ?? defaultFilters;
  },
);
